import { render, staticRenderFns } from "./map-base.vue?vue&type=template&id=54e0c2a4&"
import script from "./map-base.vue?vue&type=script&lang=js&"
export * from "./map-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports